"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _flowRight = _interopRequireDefault(require("lodash/flowRight"));
var _Nav = _interopRequireDefault(require("./Nav.component"));
var _withAppConfig = _interopRequireDefault(require("../HOCs/withAppConfig"));
var _withHeaderApi = _interopRequireDefault(require("../HOCs/withHeaderApi"));
var _withUserAndPreferences = _interopRequireDefault(require("../HOCs/withUserAndPreferences"));
const getQueryOptions = props => ({
  fetchPolicy: props.authReady ? 'cache-and-network' : 'cache-only'
});
var _default = exports.default = (0, _flowRight.default)(_withAppConfig.default, _withHeaderApi.default, Component => props => (0, _withUserAndPreferences.default)(Component, getQueryOptions(props))(props))(_Nav.default);